
<div class="wideoWreapper">
    
    <div>
 <div #target class="player previewPlayer" ></div>
</div>
</div>
